import { Grid } from "@mui/material";
import Page from "../../Components/MetaPage/Page";
import PaymentDetail from "../../Components/PaymentDetail/PaymentDetail";
import PaymentMethod from "../../Components/PaymentMethod/PaymentMethod";
import { getRemoteValue } from "../../Utils/firebase";
import useAuthState from "../../Utils/store";

const CheckoutPage = () => {
  const { isAllPayment } = useAuthState();

  return (
    <Page title={getRemoteValue("payments")}>
      <div className="md:p-[4%] lg:p-[6%] !py-0">
        <div className="px-4 py-8 ml:hidden">
          <h2 color="#191B1E" className="xs:text-md md:text-xl font-bold">
            Ödeme Yöntemi
          </h2>
          <p className="pt-2 xs:text-sm md:text-base font-normal">
            Ödemeni yapabilmek için öncesinde ödeme yöntemini seçmelisin.
            Ödemeni Havale/ EFT yoluyla veya kredi kartı ile yapabilirsin.
          </p>
        </div>
        <Grid container>
          <Grid
            item
            xs={12}
            sm={12}
            md={7}
            lg={8}
            order={{ xs: 2, sm: 2, md: 1, lg: 1 }}
          >
            <PaymentMethod isAllPayment={isAllPayment} />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={5}
            lg={4}
            order={{ xs: 1, sm: 1, md: 2, lg: 2 }}
          >
            <PaymentDetail />
          </Grid>
        </Grid>
      </div>
    </Page>
  );
};

export default CheckoutPage;
